import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCross(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.2322 16.0001L5.23218 25.0001L6.99994 26.7678L15.9999 17.7679L24.9999 26.7678L26.7676 25.0001L17.7677 16.0001L26.7676 7.0002L24.9998 5.23243L15.9999 14.2323L7 5.23242L5.23224 7.00019L14.2322 16.0001Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCross);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
